import { render, staticRenderFns } from "./TransactionSummary.vue?vue&type=template&id=4ab39718&scoped=true&"
import script from "./TransactionSummary.vue?vue&type=script&lang=ts&"
export * from "./TransactionSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionSummary.vue?vue&type=style&index=0&id=4ab39718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab39718",
  null
  
)

export default component.exports